@use '../../styles/tokens' as *;

.popoverTarget {
  display: flex !important; // Blueprint's inline-block target span doesn't center in the nav row
  align-items: center;
}

.cartButton {
  margin: 0 $appNavHeadingMargin;
}

.countTag {
  margin-left: $space0_5;
}

.preview {
  display: flex;
  flex-direction: column;
  width: 52rem;
  max-width: 90vw;
}

.previewHeader {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: $gapSnug;
  padding: $paddingDefault;
  border-bottom: 1px solid $colorLightGray;
}

.previewTitle {
  font-weight: 600;
}

.previewCount {
  color: $colorDarkestGray;
  font-size: 1.2rem;
}

.capNotice {
  padding: $paddingSnug $paddingDefault;
  background: $colorOffYellow;
  color: $colorDarkestGray;
  font-size: 1.2rem;
}

.items {
  overflow-y: auto;
  // A full cart is 50 rows, so the list scales with the window instead of pinning to a row count.
  max-height: 60vh;
  padding: 0 $paddingDefault;
}

.item + .item {
  border-top: 1px solid $colorLightGray;
}

.footer {
  display: flex;
  flex-direction: column;
  gap: $gapSnug;
  padding: $paddingDefault;
  border-top: 1px solid $colorLightGray;
}

.total {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-weight: 600;
}

.totalAmount {
  font-variant-numeric: tabular-nums;
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $gapExtraSnug;
  padding: $paddingSpacious $paddingDefault;
  text-align: center;
}

.emptyStateIcon {
  color: $colorGray;
}

.emptyStateTitle {
  font-weight: 600;
}

.emptyStateHint {
  color: $colorDarkestGray;
  font-size: 1.2rem;
}
